import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import { Timeline, Event, IconMarker} from './Timeline';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default class Events extends Component {
    render() {
        return (
            <div className="transition-item">
                <div className="jumbotron text-center" style={{paddingTop: 0}}>
                    <h1>
                        Events
                    </h1>
                    <p className="lead">Jährlich findet mindestens ein Konzert statt, in dem die Kinder erlernte Stücke
                        vorspielen können und so nicht das Gefühl bekommen, einsam vor sich hin zu üben/allein
                        am Klavier zu sein.
                    </p>
                    <p className="lead">Nach Möglichkeit bilden wir auch Ensembles zum vierhändigen Spiel oder
                        mit anderen Instrumenten.</p>
                </div>

                <h1 className="text-muted text-center">2020</h1>

                <div className="jumbotron text-center">
                    <p>Es sind noch keine Termine bekannt.</p>
                </div>

                {/* <Row>
                    <Col md={6}>
                        <Event date={new Date(2017)}
                               title="Preisträgerkonzert"
                               map={{
                                zoom: 12,
                                marker: <IconMarker
                                            lat={48.13832}
                                            lng={11.570213}
                                            >fp fp-location-pin</IconMarker>
                                }}>
                            Hello
                        </Event>
                    </Col>
                    <Col md={6}>
                        <Event date={new Date(2017)}
                               title="Preisträgerkonzert"
                               map={{
                                zoom: 12,
                                marker: <IconMarker
                                            lat={48.13832}
                                            lng={11.570213}
                                            >fp fp-location-pin</IconMarker>
                                }}>
                            Hello
                        </Event>
                    </Col>
                </Row> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Events.js